import { render, staticRenderFns } from "./checkStep2.vue?vue&type=template&id=6ebcfb84&scoped=true&"
import script from "./checkStep2.vue?vue&type=script&lang=js&"
export * from "./checkStep2.vue?vue&type=script&lang=js&"
import style0 from "./checkStep2.vue?vue&type=style&index=0&id=6ebcfb84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcfb84",
  null
  
)

export default component.exports